export const agentPerformanceDashboard = [
  {
    id: "3",
    agent_name: "Alice Johnson",
    supervisor_name: "John Doe",
    created_at: "06-22-2024",
    total_violations: 189,
    kpi_data: {
      total_calls: 151,
      compliant_calls: 95,
      non_compliant_calls: 56,
      compliance_score: 80,
      csat_score: 70,
    },
    category_scores: {
      greeting: 17,
      customer_verification: 17,
      hipaa_compliance: 15,
      delivery: 17,
      call_back: 18,
      closing: 15,
      topic_sense: 15,
    },
    campaigns: [
      {
        campaign_name: "North Western Medicine",
        categories: [
          {
            category_name: "greeting",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 12,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "customer_verification",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 13,
              },
              {
                name: "Neutral",
                value: 8,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "hipaa_compliance",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 8,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "delivery",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "call_back",
            score: 10,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 8,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "closing",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 12,
              },
              {
                name: "Neutral",
                value: 8,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "topic_sense",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 7,
              },
              {
                name: "Neutral",
                value: 2,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
        ],
        sentences: [
          {
            category_name: "Recording Statement",
            children: [
              {
                category_name: "This call is recorded for quality purposes.",
                value: 12010,
              },
              {
                category_name: "Please note, this call will be recorded.",
                value: 5842,
              },
              {
                category_name:
                  "I need to inform you this call is being recorded.",
                value: 17010,
              },
            ],
          },
          {
            category_name: "Patient information",
            children: [
              {
                category_name: "Can I have your full name, please?",
                value: 17010,
              },
              {
                category_name: "May I verify your date of birth?",
                value: 5842,
              },
              {
                category_name: "Could you provide your patient ID number?",
                value: 1041,
              },
            ],
          },
          {
            category_name: "Insurance information",
            children: [
              {
                category_name: "Which medication do you need refilled?",
                value: 17010,
              },
              {
                category_name:
                  "Can you confirm the dosage for this medication?",
                value: 7010,
              },
              {
                category_name: "When was your last refill?",
                value: 6385,
              },
            ],
          },
          {
            category_name: "Payment Options",
            children: [
              {
                category_name: "Which pharmacy do you prefer for this refill?",
                value: 1280,
              },
              {
                category_name:
                  "Can you provide your pharmacy's contact details?",
                value: 2700,
              },
              {
                category_name: "Is your pharmacy the same as last time?",
                value: 5400,
              },
            ],
          },
          {
            category_name: "Required Documents",
            children: [
              {
                category_name: "Can you confirm your insurance provider?",
                value: 2010,
              },
              {
                category_name: "Do you have your insurance card handy?",
                value: 17320,
              },
              {
                category_name:
                  "Has your insurance information changed recently?",
                value: 17010,
              },
            ],
          },
          {
            category_name: "How To Cancel",
            children: [
              {
                category_name: "How would you like to pay for this refill?",
                value: 17010,
              },
              {
                category_name: "We accept credit, debit, or insurance.",
                value: 7910,
              },
              {
                category_name: "Do you have any copay for this medication?",
                value: 7910,
              },
            ],
          },
          {
            category_name: "Terms & Conditions",
            children: [
              {
                category_name: "Take one pill daily with water.",
                value: 17010,
              },
              {
                category_name: "Store the medication at room temperature.",
                value: 18010,
              },
              {
                category_name:
                  "Follow the dosage as prescribed by your doctor.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Closing",
            children: [
              {
                category_name: "Thank you for calling. Have a great day!",
                value: 17010,
              },
              {
                category_name:
                  "If you need further assistance, please call us back.",
                value: 18010,
              },
            ],
          },
        ],
      },
      {
        campaign_name: "Upgrades",
        categories: [
          {
            category_name: "greeting",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "customer_verification",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 8,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "hipaa_compliance",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 8,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "delivery",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "call_back",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 20,
              },
              {
                name: "Neutral",
                value: 15,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "closing",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "topic_sense",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 8,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
        ],
        sentences: [
          {
            category_name: "Recording Statement",
            children: [
              {
                category_name: "This call is recorded for quality purposes.",
                value: 12010,
              },
              {
                category_name: "Please note, this call will be recorded.",
                value: 5842,
              },
              {
                category_name:
                  "I need to inform you this call is being recorded.",
                value: 17010,
              },
            ],
          },
          {
            category_name: "Patient Identification",
            children: [
              {
                category_name: "Can I have your full name, please?",
                value: 17010,
              },
              {
                category_name: "May I verify your date of birth?",
                value: 5842,
              },
              {
                category_name: "Could you provide your patient ID number?",
                value: 1041,
              },
            ],
          },
          {
            category_name: "Medication Details",
            children: [
              {
                category_name: "Which medication do you need refilled?",
                value: 17010,
              },
              {
                category_name:
                  "Can you confirm the dosage for this medication?",
                value: 7010,
              },
              {
                category_name: "When was your last refill?",
                value: 6385,
              },
            ],
          },
          {
            category_name: "Pharmacy Information",
            children: [
              {
                category_name: "Which pharmacy do you prefer for this refill?",
                value: 1280,
              },
              {
                category_name:
                  "Can you provide your pharmacy's contact details?",
                value: 2700,
              },
              {
                category_name: "Is your pharmacy the same as last time?",
                value: 5400,
              },
            ],
          },
          {
            category_name: "Insurance Verification",
            children: [
              {
                category_name: "Can you confirm your insurance provider?",
                value: 2010,
              },
              {
                category_name: "Do you have your insurance card handy?",
                value: 17320,
              },
              {
                category_name:
                  "Has your insurance information changed recently?",
                value: 17010,
              },
            ],
          },
          {
            category_name: "Payment Options",
            children: [
              {
                category_name: "How would you like to pay for this refill?",
                value: 17010,
              },
              {
                category_name: "We accept credit, debit, or insurance.",
                value: 7910,
              },
              {
                category_name: "Do you have any copay for this medication?",
                value: 7910,
              },
            ],
          },
          {
            category_name: "Refill Instructions",
            children: [
              {
                category_name: "Take one pill daily with water.",
                value: 17010,
              },
              {
                category_name: "Store the medication at room temperature.",
                value: 18010,
              },
              {
                category_name:
                  "Follow the dosage as prescribed by your doctor.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Side Effects and Warnings",
            children: [
              {
                category_name:
                  "Are you aware of the possible side effects of this medication?",
                value: 17010,
              },
              {
                category_name:
                  "If you experience any side effects, contact your doctor immediately.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Closing",
            children: [
              {
                category_name: "Thank you for calling. Have a great day!",
                value: 17010,
              },
              {
                category_name:
                  "If you need further assistance, please call us back.",
                value: 18010,
              },
            ],
          },
        ],
      },
    ],
    category_violations: {
      greeting: 10,
      customer_verification: 15,
      hipaa_compliance: 20,
      call_back: 25,
      closing: 30,
      topic_Sense: 40,
      delivery: 49,
    },
    compliant_calls_emotion_scores: {
      positive: 35,
      neutral: 12,
      negative: 2,
    },
    non_compliant_calls_emotion_scores: {
      positive: 38,
      neutral: 10,
      negative: 2,
    },
    sentimental_analysis_scores: [
      {
        name: "Negative Sentiment",
        values: [0, 30, 45, 35, 60, 30, 40, 50],
        color: "#FF9999",
      },
      {
        name: "Positive Sentiment",
        values: [80, 85, 75, 95, 100, 90, 100],
        color: "#66B2FF",
      },
      {
        name: "Neutral Sentiment",
        values: [55, 55, 60, 65, 65, 70, 70],
        color: "#FFC266",
      },
    ],
  },
  {
    id: "4",
    agent_name: "Brian Smith",
    supervisor_name: "Jane Smith",
    created_at: "07-07-2024",
    total_violations: 103,
    kpi_data: {
      total_calls: 151,
      compliant_calls: 95,
      non_compliant_calls: 56,
      compliance_score: 90,
      csat_score: 74,
    },
    category_scores: {
      greeting: 18,
      customer_verification: 16,
      hipaa_compliance: 16,
      delivery: 18,
      call_back: 16,
      closing: 16,
      topic_sense: 14,
    },
    campaigns: [
      {
        campaign_name: "New Year Offer",
        categories: [
          {
            category_name: "greeting",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "customer_verification",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "hipaa_compliance",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 8,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "delivery",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "call_back",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "closing",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "topic_sense",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 8,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
        ],
        sentences: [
          {
            category_name: "Recording Statement",
            children: [
              {
                category_name: "This call is recorded for quality purposes.",
                value: 12010,
              },
              {
                category_name: "Please note, this call will be recorded.",
                value: 5842,
              },
              {
                category_name:
                  "I need to inform you this call is being recorded.",
                value: 17010,
              },
            ],
          },
          {
            category_name: "Patient Identification",
            children: [
              {
                category_name: "Can I have your full name, please?",
                value: 17010,
              },
              {
                category_name: "May I verify your date of birth?",
                value: 5842,
              },
              {
                category_name: "Could you provide your patient ID number?",
                value: 1041,
              },
            ],
          },
          {
            category_name: "Medication Details",
            children: [
              {
                category_name: "Which medication do you need refilled?",
                value: 17010,
              },
              {
                category_name:
                  "Can you confirm the dosage for this medication?",
                value: 7010,
              },
              {
                category_name: "When was your last refill?",
                value: 6385,
              },
            ],
          },
          {
            category_name: "Pharmacy Information",
            children: [
              {
                category_name: "Which pharmacy do you prefer for this refill?",
                value: 1280,
              },
              {
                category_name:
                  "Can you provide your pharmacy's contact details?",
                value: 2700,
              },
              {
                category_name: "Is your pharmacy the same as last time?",
                value: 5400,
              },
            ],
          },
          {
            category_name: "Insurance Verification",
            children: [
              {
                category_name: "Can you confirm your insurance provider?",
                value: 2010,
              },
              {
                category_name: "Do you have your insurance card handy?",
                value: 17320,
              },
              {
                category_name:
                  "Has your insurance information changed recently?",
                value: 17010,
              },
            ],
          },
          {
            category_name: "Payment Options",
            children: [
              {
                category_name: "How would you like to pay for this refill?",
                value: 17010,
              },
              {
                category_name: "We accept credit, debit, or insurance.",
                value: 7910,
              },
              {
                category_name: "Do you have any copay for this medication?",
                value: 7910,
              },
            ],
          },
          {
            category_name: "Refill Instructions",
            children: [
              {
                category_name: "Take one pill daily with water.",
                value: 17010,
              },
              {
                category_name: "Store the medication at room temperature.",
                value: 18010,
              },
              {
                category_name:
                  "Follow the dosage as prescribed by your doctor.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Side Effects and Warnings",
            children: [
              {
                category_name:
                  "Are you aware of the possible side effects of this medication?",
                value: 17010,
              },
              {
                category_name:
                  "If you experience any side effects, contact your doctor immediately.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Closing",
            children: [
              {
                category_name: "Thank you for calling. Have a great day!",
                value: 17010,
              },
              {
                category_name:
                  "If you need further assistance, please call us back.",
                value: 18010,
              },
            ],
          },
        ],
      },
      {
        campaign_name: "Collection",
        categories: [
          {
            category_name: "greeting",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 25,
              },
              {
                name: "Neutral",
                value: 15,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "customer_verification",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 30,
              },
              {
                name: "Neutral",
                value: 25,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "hipaa_compliance",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 25,
              },
              {
                name: "Neutral",
                value: 20,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "delivery",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "call_back",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 25,
              },
              {
                name: "Neutral",
                value: 20,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "closing",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 30,
              },
              {
                name: "Neutral",
                value: 25,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "topic_sense",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 8,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
        ],
        sentences: [
          {
            category_name: "Recording Statement",
            children: [
              {
                category_name:
                  "This call is being recorded for quality assurance",
                value: 12010,
              },
              {
                category_name: "Please note, this call may be recorded.",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Patient Identification",
            children: [
              {
                category_name: "Can I have your full name and date of birth?",
                value: 17010,
              },
              {
                category_name:
                  "Please confirm your contact number and email address.",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Mini Miranda",
            children: [
              {
                category_name: "Dr. Smith is available next Tuesday at ",
                value: 17010,
              },
              {
                category_name:
                  "Would you prefer a morning or afternoon appointment?",
                value: 7010,
              },
            ],
          },
          {
            category_name: "Collection Amount",
            children: [
              {
                category_name:
                  "Is this for a general check-up or a specific concern?",
                value: 1280,
              },
              {
                category_name:
                  "Are you scheduling a follow-up or a new consultation?",
                value: 5400,
              },
            ],
          },
          {
            category_name: "Patient's readiness to make the Payment",
            children: [
              {
                category_name: "Can you provide your insurance policy number?",
                value: 2010,
              },
              {
                category_name:
                  "Is this visit covered under your current insurance plan?",
                value: 17320,
              },
            ],
          },
          {
            category_name: "Payment Options",
            children: [
              {
                category_name:
                  "We accept credit cards and online payments. What works best?",
                value: 17010,
              },
              {
                category_name:
                  "Would you like to pay now or at the time of consultation?",
                value: 7910,
              },
            ],
          },
          {
            category_name: "Consequences of delayed Payment",
            children: [
              {
                category_name: "Do you have access to a camera and microphone?",
                value: 17010,
              },
              {
                category_name:
                  "Ensure your internet connection is stable for the video call.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Closing",
            children: [
              {
                category_name:
                  "Thank you for booking with us. Have a great day!",
                value: 17010,
              },
              {
                category_name:
                  "If you have any questions, please don't hesitate to call back.",
                value: 18010,
              },
            ],
          },
        ],
      },
    ],
    category_violations: {
      greeting: 10,
      customer_verification: 18,
      hipaa_compliance: 20,
      call_back: 14,
      closing: 12,
      topic_Sense: 10,
      delivery: 14,
    },
    compliant_calls_emotion_scores: {
      positive: 58,
      neutral: 7,
      negative: 5,
    },
    non_compliant_calls_emotion_scores: {
      positive: 26,
      neutral: 7,
      negative: 2,
    },
    sentimental_analysis_scores: [
      {
        name: "Positive Sentiment",
        values: [80, 85, 75, 95, 100, 90, 100],
        color: "#66B2FF",
      },
      {
        name: "Neutral Sentiment",
        values: [55, 55, 60, 65, 65, 70, 70],
        color: "#FFC266",
      },
    ],
  },
  {
    id: "5",
    agent_name: "Charlie Brown",
    supervisor_name: "John Doe",
    created_at: "07-09-2024",
    total_violations: 188,
    kpi_data: {
      total_calls: 151,
      compliant_calls: 95,
      non_compliant_calls: 56,
      compliance_score: 85,
      csat_score: 71,
    },
    category_scores: {
      greeting: 7,
      customer_verification: 8,
      hipaa_compliance: 9,
      delivery: 7,
      call_back: 8,
      closing: 9,
      topic_sense: 8,
    },
    campaigns: [
      {
        campaign_name: "New Year Offer",
        categories: [
          {
            category_name: "greeting",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "customer_verification",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "hipaa_compliance",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "delivery",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "call_back",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "closing",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "topic_sense",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
        ],
        sentences: [
          {
            category_name: "Recording Statement",
            children: [
              {
                category_name:
                  "This call is being recorded for quality assurance",
                value: 12010,
              },
              {
                category_name: "Please note, this call may be recorded.",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Patient Information",
            children: [
              {
                category_name: "Can I have your full name and date of birth?",
                value: 17010,
              },
              {
                category_name:
                  "Please confirm your contact number and email address.",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Doctor Availability",
            children: [
              {
                category_name: "Dr. Smith is available next Tuesday at ",
                value: 17010,
              },
              {
                category_name:
                  "Would you prefer a morning or afternoon appointment?",
                value: 7010,
              },
            ],
          },
          {
            category_name: "Consultation Type",
            children: [
              {
                category_name:
                  "Is this for a general check-up or a specific concern?",
                value: 1280,
              },
              {
                category_name:
                  "Are you scheduling a follow-up or a new consultation?",
                value: 5400,
              },
            ],
          },
          {
            category_name: "Insurance Information",
            children: [
              {
                category_name: "Can you provide your insurance policy number?",
                value: 2010,
              },
              {
                category_name:
                  "Is this visit covered under your current insurance plan?",
                value: 17320,
              },
            ],
          },
          {
            category_name: "Payment Options",
            children: [
              {
                category_name:
                  "We accept credit cards and online payments. What works best?",
                value: 17010,
              },
              {
                category_name:
                  "Would you like to pay now or at the time of consultation?",
                value: 7910,
              },
            ],
          },
          {
            category_name: "Technical Requirements",
            children: [
              {
                category_name: "Do you have access to a camera and microphone?",
                value: 17010,
              },
              {
                category_name:
                  "Ensure your internet connection is stable for the video call.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Cancellation Policy",
            children: [
              {
                category_name:
                  "You can cancel up to 24 hours before the appointment.",
                value: 17010,
              },
              {
                category_name:
                  "There's a $20 fee for cancellations made less than 24 hours prior.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Closing",
            children: [
              {
                category_name:
                  "Thank you for booking with us. Have a great day!",
                value: 17010,
              },
              {
                category_name:
                  "If you have any questions, please don't hesitate to call back.",
                value: 18010,
              },
            ],
          },
        ],
      },
    ],
    category_violations: {
      greeting: 22,
      customer_verification: 27,
      hipaa_compliance: 31,
      delivery: 19,
      call_back: 24,
      closing: 29,
      topic_sense: 36,
    },
    compliant_calls_emotion_scores: {
      positive: 68,
      neutral: 5,
      negative: 2,
    },
    non_compliant_calls_emotion_scores: {
      positive: 10,
      neutral: 2,
      negative: 2,
    },
    sentimental_analysis_scores: [
      {
        name: "Negative Sentiment",
        values: [10, 20, 30, 25, 40, 35, 45, 50],
        color: "#FF9999",
      },
      {
        name: "Positive Sentiment",
        values: [70, 80, 90, 85, 95, 100, 90, 95],
        color: "#66B2FF",
      },
      {
        name: "Neutral Sentiment",
        values: [50, 60, 55, 65, 60, 70, 65, 75],
        color: "#FFC266",
      },
    ],
  },
  {
    id: "6",
    agent_name: "Diana Green",
    supervisor_name: "John Doe",
    created_at: "07-12-2024",
    total_violations: 208,
    kpi_data: {
      total_calls: 151,
      compliant_calls: 95,
      non_compliant_calls: 56,
      compliance_score: 75,
      csat_score: 68,
    },
    category_scores: {
      greeting: 10,
      customer_verification: 9,
      hipaa_compliance: 8,
      delivery: 9,
      call_back: 7,
      closing: 7,
      topic_sense: 6,
    },
    campaigns: [
      {
        campaign_name: "Upgrades",
        categories: [
          {
            category_name: "greeting",
            score: 10,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "customer_verification",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "hipaa_compliance",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "delivery",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "call_back",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "closing",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "topic_sense",
            score: 6,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
        ],
        sentences: [
          {
            category_name: "Recording Statement",
            children: [
              {
                category_name:
                  "This call is being recorded for quality purposes.",
                value: 12010,
              },
              {
                category_name: "Please be aware, this call may be recorded.",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Patient Identification",
            children: [
              {
                category_name:
                  "Can you confirm your full name and date of birth?",
                value: 17010,
              },
              {
                category_name:
                  "May I have your contact number for verification?",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Health Status Update",
            children: [
              {
                category_name:
                  "How have you been feeling since your last visit?",
                value: 17010,
              },
              {
                category_name: "Have there been any changes in your symptoms?",
                value: 7010,
              },
            ],
          },
          {
            category_name: "Medication Adherence",
            children: [
              {
                category_name: "Are you taking your medications as prescribed?",
                value: 1280,
              },
              {
                category_name: "Have you missed any doses of your medication?",
                value: 5400,
              },
            ],
          },
          {
            category_name: "Appointment Reminders",
            children: [
              {
                category_name:
                  "Your next appointment is scheduled for next Monday at 3 PM.",
                value: 2010,
              },
              {
                category_name:
                  "Just a reminder, your follow-up is next Friday.",
                value: 17320,
              },
            ],
          },
          {
            category_name: "Follow-Up Actions",
            children: [
              {
                category_name:
                  "Please continue with your current treatment plan.",
                value: 17010,
              },
              {
                category_name:
                  "Your doctor recommends a blood test before the next visit.",
                value: 7910,
              },
            ],
          },
          {
            category_name: "Next Appointment Scheduling",
            children: [
              {
                category_name:
                  "When would you like to schedule your next appointment?",
                value: 17010,
              },
              {
                category_name:
                  "Is a morning or afternoon appointment more convenient for you?",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Patient Feedback",
            children: [
              {
                category_name: "Do you have any feedback on your recent visit?",
                value: 17010,
              },
              {
                category_name:
                  "How satisfied are you with your current treatment plan?",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Closing",
            children: [
              {
                category_name: "Thank you for your time. Take care!",
                value: 17010,
              },
              {
                category_name:
                  "If you need further assistance, please call us back.",
                value: 18010,
              },
            ],
          },
        ],
      },
    ],
    category_violations: {
      greeting: 30,
      customer_verification: 25,
      hipaa_compliance: 28,
      delivery: 30,
      call_back: 20,
      closing: 40,
      topic_sense: 32,
    },
    compliant_calls_emotion_scores: {
      positive: 68,
      neutral: 10,
      negative: 2,
    },
    non_compliant_calls_emotion_scores: {
      positive: 23,
      neutral: 5,
      negative: 2,
    },
    sentimental_analysis_scores: [
      {
        name: "Negative Sentiment",
        values: [15, 25, 35, 30, 45, 40, 50, 55],
        color: "#FF9999",
      },
      {
        name: "Positive Sentiment",
        values: [60, 70, 80, 75, 90, 85, 95, 100],
        color: "#66B2FF",
      },
    ],
  },
  {
    id: "7",
    agent_name: "Eve Harris",
    supervisor_name: "John Doe",
    created_at: "06-15-2024",
    total_violations: 95,
    kpi_data: {
      total_calls: 151,
      compliant_calls: 95,
      non_compliant_calls: 56,
      compliance_score: 80,
      csat_score: 76,
    },
    category_scores: {
      greeting: 9,
      customer_verification: 7,
      hipaa_compliance: 10,
      delivery: 8,
      call_back: 9,
      closing: 8,
      topic_sense: 7,
    },
    campaigns: [
      {
        campaign_name: "North Western Medicine",
        categories: [
          {
            category_name: "greeting",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "customer_verification",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "hipaa_compliance",
            score: 10,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "delivery",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "call_back",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "closing",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "topic_sense",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 16,
              },
              {
                name: "Neutral",
                value: 8,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
        ],
        sentences: [
          {
            category_name: "Recording Statement",
            children: [
              {
                category_name:
                  "This call is being recorded for quality assurance.",
                value: 12010,
              },
              {
                category_name:
                  "Please note, this call may be recorded for training purposes.",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Patient Identification",
            children: [
              {
                category_name:
                  "Can you confirm your full name and date of birth?",
                value: 17010,
              },
              {
                category_name:
                  "May I have your contact number for verification?",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Insurance Policy Details",
            children: [
              {
                category_name:
                  "Can you provide your insurance policy number, please?",
                value: 17010,
              },
              {
                category_name: "What is the name of your insurance provider?",
                value: 7010,
              },
            ],
          },
          {
            category_name: "Coverage Confirmation",
            children: [
              {
                category_name: "Does your policy cover specialist visits?",
                value: 1280,
              },
              {
                category_name: "Are prescriptions included in your coverage?",
                value: 5400,
              },
            ],
          },
          {
            category_name: "Co-Pay Information",
            children: [
              {
                category_name: "What is your co-pay amount for office visits?",
                value: 2010,
              },
              {
                category_name:
                  "Do you have a co-pay for specialist consultations?",
                value: 17320,
              },
            ],
          },
          {
            category_name: "Deductible Status",
            children: [
              {
                category_name:
                  "How much of your deductible have you met this year?",
                value: 17010,
              },
              {
                category_name:
                  "Can you confirm your current deductible status?",
                value: 7910,
              },
            ],
          },
          {
            category_name: "Pre-Authorization Requirements",
            children: [
              {
                category_name:
                  "Do you need pre-authorization for this procedure?",
                value: 17010,
              },
              {
                category_name:
                  "Has your insurance provider approved this service?",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Payment Options",
            children: [
              {
                category_name:
                  "We accept credit cards and online payments. What’s your preference?",
                value: 17010,
              },
              {
                category_name: "Would you like to set up automatic payments?",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Closing",
            children: [
              {
                category_name: "Thank you for your time. Have a great day!",
                value: 17010,
              },
              {
                category_name:
                  "If you have any more questions, please call us back.",
                value: 18010,
              },
            ],
          },
        ],
      },
    ],
    category_violations: {
      greeting: 8,
      customer_verification: 12,
      hipaa_compliance: 15,
      delivery: 10,
      call_back: 17,
      closing: 14,
      topic_sense: 19,
    },
    compliant_calls_emotion_scores: {
      positive: 78,
      neutral: 5,
      negative: 2,
    },
    non_compliant_calls_emotion_scores: {
      positive: 10,
      neutral: 3,
      negative: 2,
    },
    sentimental_analysis_scores: [
      {
        name: "Negative Sentiment",
        values: [5, 15, 25, 20, 35, 30, 40, 45],
        color: "#FF9999",
      },
      {
        name: "Positive Sentiment",
        values: [75, 85, 95, 90, 100, 95, 105, 110],
        color: "#66B2FF",
      },
      {
        name: "Neutral Sentiment",
        values: [45, 55, 50, 60, 55, 65, 60, 70],
        color: "#FFC266",
      },
    ],
  },
  {
    id: "8",
    agent_name: "Michael Lee",
    supervisor_name: "Richard Williams",
    created_at: "06-28-2024",
    total_violations: 97,
    kpi_data: {
      total_calls: 151,
      compliant_calls: 95,
      non_compliant_calls: 56,
      compliance_score: 85,
      csat_score: 69,
    },
    category_scores: {
      greeting: 8,
      customer_verification: 9,
      hipaa_compliance: 10,
      delivery: 7,
      call_back: 8,
      closing: 9,
      topic_sense: 8,
    },
    campaigns: [
      {
        campaign_name: "Upgrades",
        categories: [
          {
            category_name: "greeting",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "customer_verification",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 1,
              },
            ],
          },
          {
            category_name: "hipaa_compliance",
            score: 10,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "delivery",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "call_back",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "closing",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "topic_sense",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 7,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
        ],
        sentences: [
          {
            category_name: "Recording Statement",
            children: [
              {
                category_name:
                  "This call is being recorded for quality assurance.",
                value: 12010,
              },
              {
                category_name: "Please note, this call may be recorded.",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Patient Identification",
            children: [
              {
                category_name:
                  "Can you confirm your full name and date of birth?",
                value: 17010,
              },
              {
                category_name:
                  "May I have your contact number for verification?",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Vaccine Eligibility",
            children: [
              {
                category_name:
                  "Are you currently eligible for the COVID-19 vaccine?",
                value: 17010,
              },
              {
                category_name:
                  "Have you received any vaccines in the last month?",
                value: 7010,
              },
            ],
          },
          {
            category_name: "Vaccine Availability",
            children: [
              {
                category_name:
                  "The next available appointment is on Monday at 10 AM.",
                value: 1280,
              },
              {
                category_name:
                  "We have openings for vaccinations on Thursday afternoon.",
                value: 5400,
              },
            ],
          },
          {
            category_name: "Scheduling Appointment",
            children: [
              {
                category_name:
                  "When would you like to schedule your vaccination?",
                value: 2010,
              },
              {
                category_name:
                  "Is a morning or afternoon appointment more convenient for you?",
                value: 17320,
              },
            ],
          },
          {
            category_name: "Insurance Verification",
            children: [
              {
                category_name: "Can you provide your insurance policy number?",
                value: 17010,
              },
              {
                category_name:
                  "Is the vaccination covered under your current insurance plan?",
                value: 7910,
              },
            ],
          },
          {
            category_name: "Side Effects and Warnings",
            children: [
              {
                category_name:
                  "Possible side effects include mild fever and soreness at the site.",
                value: 17010,
              },
              {
                category_name:
                  "Contact your doctor if you experience severe side effects.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Post-Vaccination Instructions",
            children: [
              {
                category_name:
                  "Please wait for 15 minutes after your shot for observation.",
                value: 17010,
              },
              {
                category_name:
                  "Drink plenty of fluids and rest after the vaccination.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Closing",
            children: [
              {
                category_name: "Thank you for scheduling. Stay safe!",
                value: 17010,
              },
              {
                category_name:
                  "If you have any questions, please call us back.",
                value: 18010,
              },
            ],
          },
        ],
      },
    ],
    category_violations: {
      greeting: 10,
      customer_verification: 13,
      hipaa_compliance: 14,
      delivery: 11,
      call_back: 15,
      closing: 16,
      topic_sense: 18,
    },
    compliant_calls_emotion_scores: {
      positive: 42,
      neutral: 7,
      negative: 1,
    },
    non_compliant_calls_emotion_scores: {
      positive: 23,
      neutral: 25,
      negative: 2,
    },
    sentimental_analysis_scores: [
      {
        name: "Negative Sentiment",
        values: [20, 30, 40, 35, 50, 45, 55, 60],
        color: "#FF9999",
      },
      {
        name: "Positive Sentiment",
        values: [65, 75, 85, 80, 90, 85, 95, 100],
        color: "#66B2FF",
      },
      {
        name: "Neutral Sentiment",
        values: [35, 45, 40, 50, 45, 55, 50, 60],
        color: "#FFC266",
      },
    ],
  },
  {
    id: "9",
    agent_name: "Sarah Johnson",
    supervisor_name: "Jane Smith",
    created_at: "06-30-2024",
    total_violations: 103,
    kpi_data: {
      total_calls: 151,
      compliant_calls: 95,
      non_compliant_calls: 56,
      compliance_score: 80,
      csat_score: 73,
    },
    category_scores: {
      greeting: 9,
      customer_verification: 8,
      hipaa_compliance: 10,
      delivery: 8,
      call_back: 7,
      closing: 8,
      topic_sense: 9,
    },
    campaigns: [
      {
        campaign_name: "Collection",
        categories: [
          {
            category_name: "greeting",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "customer_verification",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "hipaa_compliance",
            score: 10,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "delivery",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "call_back",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "closing",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "topic_sense",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
        ],
        sentences: [
          {
            category_name: "Recording Statement",
            children: [
              {
                category_name:
                  "This call is being recorded for quality assurance",
                value: 12010,
              },
              {
                category_name: "Please note, this call may be recorded.",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Patient Identification",
            children: [
              {
                category_name: "Can I have your full name and date of birth?",
                value: 17010,
              },
              {
                category_name:
                  "Please confirm your contact number and email address.",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Mini Miranda",
            children: [
              {
                category_name: "Dr. Smith is available next Tuesday at ",
                value: 17010,
              },
              {
                category_name:
                  "Would you prefer a morning or afternoon appointment?",
                value: 7010,
              },
            ],
          },
          {
            category_name: "Collection Amount",
            children: [
              {
                category_name:
                  "Is this for a general check-up or a specific concern?",
                value: 1280,
              },
              {
                category_name:
                  "Are you scheduling a follow-up or a new consultation?",
                value: 5400,
              },
            ],
          },
          {
            category_name: "Patient's readiness to make the Payment",
            children: [
              {
                category_name: "Can you provide your insurance policy number?",
                value: 2010,
              },
              {
                category_name:
                  "Is this visit covered under your current insurance plan?",
                value: 17320,
              },
            ],
          },
          {
            category_name: "Payment Options",
            children: [
              {
                category_name:
                  "We accept credit cards and online payments. What works best?",
                value: 17010,
              },
              {
                category_name:
                  "Would you like to pay now or at the time of consultation?",
                value: 7910,
              },
            ],
          },
          {
            category_name: "Consequences of delayed Payment",
            children: [
              {
                category_name: "Do you have access to a camera and microphone?",
                value: 17010,
              },
              {
                category_name:
                  "Ensure your internet connection is stable for the video call.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Closing",
            children: [
              {
                category_name:
                  "Thank you for booking with us. Have a great day!",
                value: 17010,
              },
              {
                category_name:
                  "If you have any questions, please don't hesitate to call back.",
                value: 18010,
              },
            ],
          },
        ],
      },
    ],
    category_violations: {
      greeting: 12,
      customer_verification: 14,
      hipaa_compliance: 11,
      delivery: 16,
      call_back: 17,
      closing: 13,
      topic_sense: 12,
    },
    compliant_calls_emotion_scores: {
      positive: 55,
      neutral: 7,
      negative: 3,
    },
    non_compliant_calls_emotion_scores: {
      positive: 27,
      neutral: 7,
      negative: 1,
    },
    sentimental_analysis_scores: [
      {
        name: "Negative Sentiment",
        values: [25, 35, 45, 40, 55, 50, 60, 65],
        color: "#FF9999",
      },
      {
        name: "Positive Sentiment",
        values: [55, 65, 75, 70, 85, 80, 90, 95],
        color: "#66B2FF",
      },
      {
        name: "Neutral Sentiment",
        values: [30, 40, 35, 45, 40, 50, 45, 55],
        color: "#FFC266",
      },
    ],
  },
  {
    id: "10",
    agent_name: "Michael Williams",
    supervisor_name: "Richard Williams",
    created_at: "07-20-2024",
    total_violations: 131,
    kpi_data: {
      total_calls: 151,
      compliant_calls: 95,
      non_compliant_calls: 56,
      compliance_score: 85,
      csat_score: 72,
    },
    category_scores: {
      greeting: 8,
      customer_verification: 9,
      hipaa_compliance: 9,
      delivery: 7,
      call_back: 8,
      closing: 9,
      topic_sense: 8,
    },
    campaigns: [
      {
        campaign_name: "New Year Offer",
        categories: [
          {
            category_name: "greeting",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 8,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "customer_verification",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "hipaa_compliance",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "delivery",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "call_back",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "closing",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "topic_sense",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
        ],
        sentences: [
          {
            category_name: "Recording Statement",
            children: [
              {
                category_name:
                  "This call is being recorded for quality assurance.",
                value: 12010,
              },
              {
                category_name: "Please note, this call may be recorded.",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Patient Identification",
            children: [
              {
                category_name:
                  "Can you confirm your full name and date of birth?",
                value: 17010,
              },
              {
                category_name:
                  "May I have your contact number for verification?",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Vaccine Eligibility",
            children: [
              {
                category_name:
                  "Are you currently eligible for the COVID-19 vaccine?",
                value: 17010,
              },
              {
                category_name:
                  "Have you received any vaccines in the last month?",
                value: 7010,
              },
            ],
          },
          {
            category_name: "Vaccine Availability",
            children: [
              {
                category_name:
                  "The next available appointment is on Monday at 10 AM.",
                value: 1280,
              },
              {
                category_name:
                  "We have openings for vaccinations on Thursday afternoon.",
                value: 5400,
              },
            ],
          },
          {
            category_name: "Scheduling Appointment",
            children: [
              {
                category_name:
                  "When would you like to schedule your vaccination?",
                value: 2010,
              },
              {
                category_name:
                  "Is a morning or afternoon appointment more convenient for you?",
                value: 17320,
              },
            ],
          },
          {
            category_name: "Insurance Verification",
            children: [
              {
                category_name: "Can you provide your insurance policy number?",
                value: 17010,
              },
              {
                category_name:
                  "Is the vaccination covered under your current insurance plan?",
                value: 7910,
              },
            ],
          },
          {
            category_name: "Side Effects and Warnings",
            children: [
              {
                category_name:
                  "Possible side effects include mild fever and soreness at the site.",
                value: 17010,
              },
              {
                category_name:
                  "Contact your doctor if you experience severe side effects.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Post-Vaccination Instructions",
            children: [
              {
                category_name:
                  "Please wait for 15 minutes after your shot for observation.",
                value: 17010,
              },
              {
                category_name:
                  "Drink plenty of fluids and rest after the vaccination.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Closing",
            children: [
              {
                category_name: "Thank you for scheduling. Stay safe!",
                value: 17010,
              },
              {
                category_name:
                  "If you have any questions, please call us back.",
                value: 18010,
              },
            ],
          },
        ],
      },
    ],
    category_violations: {
      greeting: 15,
      customer_verification: 18,
      hipaa_compliance: 20,
      delivery: 22,
      call_back: 10,
      closing: 23,
      topic_sense: 23,
    },
    compliant_calls_emotion_scores: {
      positive: 33,
      neutral: 15,
      negative: 2,
    },
    non_compliant_calls_emotion_scores: {
      positive: 30,
      neutral: 17,
      negative: 3,
    },
    sentimental_analysis_scores: [
      {
        name: "Negative Sentiment",
        values: [30, 40, 50, 45, 60, 55, 65, 70],
        color: "#FF9999",
      },
      {
        name: "Positive Sentiment",
        values: [50, 60, 70, 65, 80, 75, 85, 90],
        color: "#66B2FF",
      },
      {
        name: "Neutral Sentiment",
        values: [25, 35, 30, 40, 35, 45, 40, 50],
        color: "#FFC266",
      },
    ],
  },
  {
    id: "11",
    agent_name: "Samantha Lee",
    supervisor_name: "Jane Smith",
    created_at: "08-01-2024",
    total_violations: 165,
    kpi_data: {
      total_calls: 151,
      compliant_calls: 95,
      non_compliant_calls: 56,
      compliance_score: 77,
      csat_score: 72,
    },
    category_scores: {
      greeting: 9,
      customer_verification: 8,
      hipaa_compliance: 10,
      delivery: 8,
      call_back: 9,
      closing: 10,
      topic_sense: 9,
    },
    campaigns: [
      {
        campaign_name: "North Western Medicine",
        categories: [
          {
            category_name: "greeting",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "customer_verification",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "hipaa_compliance",
            score: 10,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "delivery",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "call_back",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "closing",
            score: 10,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 0,
              },
            ],
          },
          {
            category_name: "topic_sense",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
        ],
        sentences: [
          {
            category_name: "Recording Statement",
            children: [
              {
                category_name:
                  "This call is being recorded for quality purposes.",
                value: 12010,
              },
              {
                category_name: "Please be aware, this call may be recorded.",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Patient Identification",
            children: [
              {
                category_name:
                  "Can you confirm your full name and date of birth?",
                value: 17010,
              },
              {
                category_name:
                  "May I have your contact number for verification?",
                value: 5842,
              },
            ],
          },
          {
            category_name: "Health Status Update",
            children: [
              {
                category_name:
                  "How have you been feeling since your last visit?",
                value: 17010,
              },
              {
                category_name: "Have there been any changes in your symptoms?",
                value: 7010,
              },
            ],
          },
          {
            category_name: "Medication Adherence",
            children: [
              {
                category_name: "Are you taking your medications as prescribed?",
                value: 1280,
              },
              {
                category_name: "Have you missed any doses of your medication?",
                value: 5400,
              },
            ],
          },
          {
            category_name: "Appointment Reminders",
            children: [
              {
                category_name:
                  "Your next appointment is scheduled for next Monday at 3 PM.",
                value: 2010,
              },
              {
                category_name:
                  "Just a reminder, your follow-up is next Friday.",
                value: 17320,
              },
            ],
          },
          {
            category_name: "Follow-Up Actions",
            children: [
              {
                category_name:
                  "Please continue with your current treatment plan.",
                value: 17010,
              },
              {
                category_name:
                  "Your doctor recommends a blood test before the next visit.",
                value: 7910,
              },
            ],
          },
          {
            category_name: "Next Appointment Scheduling",
            children: [
              {
                category_name:
                  "When would you like to schedule your next appointment?",
                value: 17010,
              },
              {
                category_name:
                  "Is a morning or afternoon appointment more convenient for you?",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Patient Feedback",
            children: [
              {
                category_name: "Do you have any feedback on your recent visit?",
                value: 17010,
              },
              {
                category_name:
                  "How satisfied are you with your current treatment plan?",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Closing",
            children: [
              {
                category_name: "Thank you for your time. Take care!",
                value: 17010,
              },
              {
                category_name:
                  "If you need further assistance, please call us back.",
                value: 18010,
              },
            ],
          },
        ],
      },
    ],
    category_violations: {
      greeting: 20,
      customer_verification: 25,
      hipaa_compliance: 18,
      delivery: 30,
      call_back: 22,
      closing: 28,
      topic_sense: 22,
    },
    compliant_calls_emotion_scores: {
      positive: 73,
      neutral: 7,
      negative: 5,
    },
    non_compliant_calls_emotion_scores: {
      positive: 7,
      neutral: 7,
      negative: 1,
    },
    sentimental_analysis_scores: [
      {
        name: "Negative Sentiment",
        values: [35, 45, 55, 50, 65, 60, 70, 75],
        color: "#FF9999",
      },
      {
        name: "Positive Sentiment",
        values: [45, 55, 65, 60, 75, 70, 80, 85],
        color: "#66B2FF",
      },
    ],
  },
  {
    id: "12",
    agent_name: "Michael Johnson",
    supervisor_name: "Richard Williams",
    created_at: "07-19-2024",
    total_violations: 179,
    kpi_data: {
      total_calls: 151,
      compliant_calls: 95,
      non_compliant_calls: 56,
      compliance_score: 85,
      csat_score: 75,
    },
    category_scores: {
      greeting: 20,
      customer_verification: 24,
      hipaa_compliance: 27,
      delivery: 18,
      call_back: 26,
      closing: 30,
      topic_sense: 34,
    },
    campaigns: [
      {
        campaign_name: "Upgrades",
        categories: [
          {
            category_name: "greeting",
            score: 10,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "customer_verification",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "hipaa_compliance",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "delivery",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 5,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "call_back",
            score: 7,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "closing",
            score: 9,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 15,
              },
              {
                name: "Neutral",
                value: 10,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
          {
            category_name: "topic_sense",
            score: 8,
            category_emotion_scores: [
              {
                name: "Positive",
                value: 10,
              },
              {
                name: "Neutral",
                value: 2,
              },
              {
                name: "Negative",
                value: 2,
              },
            ],
          },
        ],
        sentences: [
          {
            category_name: "Recording Statement",
            children: [
              {
                category_name: "This call is recorded for quality purposes.",
                value: 12010,
              },
              {
                category_name: "Please note, this call will be recorded.",
                value: 5842,
              },
              {
                category_name:
                  "I need to inform you this call is being recorded.",
                value: 17010,
              },
            ],
          },
          {
            category_name: "Patient information",
            children: [
              {
                category_name: "Can I have your full name, please?",
                value: 17010,
              },
              {
                category_name: "May I verify your date of birth?",
                value: 5842,
              },
              {
                category_name: "Could you provide your patient ID number?",
                value: 1041,
              },
            ],
          },
          {
            category_name: "Insurance information",
            children: [
              {
                category_name: "Which medication do you need refilled?",
                value: 17010,
              },
              {
                category_name:
                  "Can you confirm the dosage for this medication?",
                value: 7010,
              },
              {
                category_name: "When was your last refill?",
                value: 6385,
              },
            ],
          },
          {
            category_name: "Payment Options",
            children: [
              {
                category_name: "Which pharmacy do you prefer for this refill?",
                value: 1280,
              },
              {
                category_name:
                  "Can you provide your pharmacy's contact details?",
                value: 2700,
              },
              {
                category_name: "Is your pharmacy the same as last time?",
                value: 5400,
              },
            ],
          },
          {
            category_name: "Required Documents",
            children: [
              {
                category_name: "Can you confirm your insurance provider?",
                value: 2010,
              },
              {
                category_name: "Do you have your insurance card handy?",
                value: 17320,
              },
              {
                category_name:
                  "Has your insurance information changed recently?",
                value: 17010,
              },
            ],
          },
          {
            category_name: "How To Cancel",
            children: [
              {
                category_name: "How would you like to pay for this refill?",
                value: 17010,
              },
              {
                category_name: "We accept credit, debit, or insurance.",
                value: 7910,
              },
              {
                category_name: "Do you have any copay for this medication?",
                value: 7910,
              },
            ],
          },
          {
            category_name: "Terms & Conditions",
            children: [
              {
                category_name: "Take one pill daily with water.",
                value: 17010,
              },
              {
                category_name: "Store the medication at room temperature.",
                value: 18010,
              },
              {
                category_name:
                  "Follow the dosage as prescribed by your doctor.",
                value: 18010,
              },
            ],
          },
          {
            category_name: "Closing",
            children: [
              {
                category_name: "Thank you for calling. Have a great day!",
                value: 17010,
              },
              {
                category_name:
                  "If you need further assistance, please call us back.",
                value: 18010,
              },
            ],
          },
        ],
      },
    ],
    category_violations: {
      greeting: 15,
      customer_verification: 18,
      hipaa_compliance: 20,
      delivery: 22,
      call_back: 10,
      closing: 23,
      topic_sense: 23,
    },
    compliant_calls_emotion_scores: {
      positive: 85,
      neutral: 7,
      negative: 3,
    },
    non_compliant_calls_emotion_scores: {
      positive: 2,
      neutral: 2,
      negative: 1,
    },
    sentimental_analysis_scores: [
      {
        name: "Negative Sentiment",
        values: [20, 30, 25, 35, 30, 40, 35, 45],
        color: "#FF9999",
      },
      {
        name: "Positive Sentiment",
        values: [35, 45, 55, 50, 65, 60, 70, 75],
        color: "#66B2FF",
      },
      {
        name: "Neutral Sentiment",
        values: [45, 55, 65, 60, 75, 70, 80, 85],
        color: "#FFC266",
      },
    ],
  },
];
